// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentMemberNumberModel {
    static getAttributeTypeMap() {
        return EnrollmentMemberNumberModel.attributeTypeMap;
    }
}
EnrollmentMemberNumberModel.discriminator = undefined;
EnrollmentMemberNumberModel.attributeTypeMap = [
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "EnrollmentType"
    }
];
//# sourceMappingURL=enrollmentMemberNumberModel.js.map